var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeclinedFile = function SvgDeclinedFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#declined-file_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.369.7c-.768 0-1.536.383-2.016.863L3.937 5.787c-.576.48-.96 1.344-.96 2.208V20.86a2.991 2.991 0 0 0 2.976 2.976h12.096a2.991 2.991 0 0 0 2.976-2.976V3.675A2.991 2.991 0 0 0 18.049.7h-7.68ZM4.897 7.994c0-.288 0-.384.096-.576.096-.096.096-.192.192-.288L9.6 2.907c.192-.192.48-.288.768-.288h.192v3.648c0 .96-.768 1.824-1.824 1.824h-3.84v-.096Zm10.272 9.888a.928.928 0 0 1 0 1.344.928.928 0 0 1-1.344 0L12 17.403l-1.824 1.824a.928.928 0 0 1-1.344 0 .928.928 0 0 1 0-1.344l1.824-1.824-1.824-1.824a.928.928 0 0 1 0-1.344.928.928 0 0 1 1.344 0L12 14.715l1.824-1.824a.928.928 0 0 1 1.344 0 .928.928 0 0 1 0 1.344l-1.824 1.824 1.824 1.824Z",
    fill: "#DC3838"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "declined-file_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .22)",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgDeclinedFile;